export default __webpack_public_path__ + "static/media/nav-arrow-gray-manatee.eedd2a6b.svg";